import { IonCol, IonGrid, IonRow, IonSpinner } from "@ionic/react";
import { digitChanger, numberWithCommas } from "helpers/helper";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function MonthlyRevenueExpense({
  erLoading,
  monthlyExpense,
  monthlyRevenue,
  ekkLanguage,
  startTime,
  endOfTime,
}) {
  let navigate = useNavigate();
  return (
    <div className="purchase-summary relative">
      <IonGrid>
        <IonRow className="cursor-pointer">
          <IonCol
            size="6"
            onClick={() => navigate(`/total-revenue/?start=${startTime}&end=${endOfTime}`)}
          >
            <div className="text-center rounded-[10px] bg-white pr-[5px] pt-1">
              <p className="text-14 text-success font-bold mb-[8px]">
                {ekkLanguage.accounting.monthlyRevenue}
              </p>
              <div>
                {erLoading ? (
                  <IonSpinner color="green"></IonSpinner>
                ) : (
                  <>
                    <p className="text-12 text-262626-1000 font-semibold mb-[10px]">
                      {digitChanger(monthlyRevenue?.revenue_count ?? 0)}{" "}
                      {ekkLanguage.accounting.revenues}
                    </p>
                    <h5 className="font-bold text-262626-1000 text-18">
                      {monthlyRevenue?.currency}
                      {numberWithCommas(
                        monthlyRevenue?.total_revenue ?? 0.0
                      )}
                    </h5>
                  </>
                )}
              </div>
            </div>
          </IonCol>
          <IonCol size="6" onClick={() => navigate(`/total-expense/?start=${startTime}&end=${endOfTime}`)}>
            <div className="text-center rounded-[10px] bg-white pl-[5px] pt-1">
              <p className="text-14 text-primary font-bold mb-[8px]">
                {ekkLanguage.accounting.monthlyExpense}
              </p>

              <div>
                {erLoading ? (
                  <IonSpinner color="green"></IonSpinner>
                ) : (
                  <>
                    <p className="text-12 text-262626-1000 font-semibold mb-[10px]">
                      {digitChanger(monthlyExpense?.expense_count ?? 0)}{" "}
                      {ekkLanguage.accounting.expenses}
                    </p>
                    <h5 className="font-bold text-262626-1000 text-18">
                      {monthlyExpense?.currency}
                      {numberWithCommas(
                        monthlyExpense?.total_expense ?? 0.0
                      )}
                    </h5>
                  </>
                )}
              </div>
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
}
